<template>
  <div class="p-3 bg-light h-100 overflow-auto">
    <div class="row g-3">
      <div class="col-md-6">
        <div class="small fw-semibold text-uppercase text-muted mb-2">
          Rate Decision Path
        </div>
        <DecisionPathList :path="params.data.decisionPath" />
      </div>
      <div class="col-md-6">
        <div class="small fw-semibold text-uppercase text-muted mb-2">
          Handling Fee Decision Path
        </div>
        <AhsDecisionPathList :path="params.data.ahsDecisionPath" />
      </div>
    </div>
  </div>
</template>

<script>
import DecisionPathList from '@/components/TestBilling/DecisionPathList.vue';
import AhsDecisionPathList from '@/components/TestBilling/AhsDecisionPathList.vue';

export default {
  components: { DecisionPathList, AhsDecisionPathList },
};
</script>
